
export enum ValueAddedServiceCode {
  LogisticsService= 'LogisticsService',
  ProvisionalLicensePlate= 'ProvisionalLicensePlate',
  VehicleNationalization= 'VehicleNationalization',
  VehicleRegistration= 'VehicleRegistration',

}